<template>
<div>
  <nav class="navbar navbar-expand-lg navbar-dark bnav">
    <a class="navbar-brand" href="#">
      <img width="120" src="@/assets/img/logo-qupro.png" alt="Qupro">
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#nav-collapse"
      aria-controls="nav-collapse"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="nav-collapse">
      <!-- COMPONENTES DEL NAVBAR-->
      <partial-menu/>
      <partial-usermenu/>
    </div>
  </nav>
    <ErrorApi/>
    <SuccessApi/>
</div>
</template>

<script>
import PartialMenu from "./Partial-menu.vue";
import PartialUsermenu from "./Partial-usermenu.vue";
import { mapActions } from 'vuex'
import ErrorApi from '../global/Errores.vue'
import SuccessApi from '../global/Success.vue'

export default {
    components: {
      PartialMenu,
      PartialUsermenu,
      ErrorApi,
      SuccessApi
    },
    methods: {
      ...mapActions({
        getAuthUser: 'authUser/getAuthUser'
      }),
    },
    mounted() {
      this.getAuthUser();
    },
}
</script>

<style scoped>
  .bnav {
    background-color: var(--navbar-bg);
  }
</style>